import { Body1 } from '@cian/ui-kit';
import { IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { MAINPAGE_FILTERS_URL, MAINPAGE_SEARCH_URL } from 'shared/constants/constants';

import { useScrollCollapseFallback } from './useScrollCollapseFallback';

import * as styles from './RedesignMainpageSearchBox.css';

export interface IRedesignMainpageSearchBoxProps {
  onSearchClick(event: React.MouseEvent<HTMLAnchorElement>): void;
  onFiltersClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

const EXPANDED_PLACEHOLDER = 'Снять однушку в Мурино';
const COLLAPSED_PLACEHOLDER = 'Что ищете?';

export const RedesignMainpageSearchBox: React.FC<IRedesignMainpageSearchBoxProps> = ({
  onSearchClick,
  onFiltersClick,
}) => {
  const rootRef = React.useRef<HTMLDivElement>(null);

  useScrollCollapseFallback(rootRef, styles['is-scrolled']);

  return (
    <div ref={rootRef} className={styles['search-box']} data-testid="RedesignMainpageSearchBox">
      <a href={MAINPAGE_SEARCH_URL} className={styles['search-field']} onClick={onSearchClick}>
        <span className={styles['placeholder-stack']}>
          <span className={styles['placeholder-expanded']}>
            <Body1 color="text-secondary-default">{EXPANDED_PLACEHOLDER}</Body1>
          </span>
          <span className={styles['placeholder-collapsed']} aria-hidden="true">
            <Body1 color="text-secondary-default">{COLLAPSED_PLACEHOLDER}</Body1>
          </span>
        </span>
      </a>
      <a
        href={MAINPAGE_FILTERS_URL}
        className={styles['filters-button']}
        onClick={onFiltersClick}
        data-testid="RedesignMainpageSearchBoxFiltersButton"
        aria-label="Фильтры"
      >
        <IconActionFilters16 />
      </a>
    </div>
  );
};

RedesignMainpageSearchBox.displayName = 'RedesignMainpageSearchBox';
